/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable react/destructuring-assignment */
import { Button, Grid, Group, Paper, Space, Text, Textarea, ThemeIcon } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconDeviceFloppy, IconNotes, IconScale, IconZoomMoney } from '@tabler/icons-react';
import { Tabs } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import BasicPriceTax, { BasicPriceTaxRef } from '../../../../components/BasicPriceTax';
import BasicPricing, { BasicPricingData, BasicPricingRef } from '../../../../components/BasicPricing';
import BasicValueUnits, {
  BasicValueUnitsData,
  BasicValueUnitsRef,
} from '../../../../components/BasicValueUnits';
import EntityAddressPicker from '../../../../components/core/EntityAddressPicker/EntityAddressPicker';
import EntityItemPicker from '../../../../components/core/EntityItemPicker/EntityItemPicker';
import PageSection from '../../../../components/core/PageSection/PageSection';
import ToleranceForm from '../../../../components/core/Tolerance/ToleranceForm';
import { EntityTypeType, UnitOfMeasureType } from '../../../../models/core/cache.type';
import { Action } from '../../../../models/core/core.type';
import { EntityAddressType, EntitySearchResponseType } from '../../../../models/core/entities.type';
import {
  ProposalResiduePlanPricingType,
  ProposalResiduePlanQuotationTreatmentType,
  ProposalResiduePlanTreatmentType,
  ProposalTipoPrecificacaoEnum,
} from '../../../../models/core/proposals.type';
import { EntityItemEnum, Feature, Financial } from '../../../../utils/constants.utils';
import { buildFakeAuditObject, isNullOrEmpty, newGuid } from '../../../../utils/helper.utils';

type FormViewData = {
  action: Action;
  id: string;
  fornecedorData: EntitySearchResponseType | null;
  idFornecedor: number | null;
  fornecedor: string;
  idEntidadeResiduoTratamento: number | null;
  enderecoData: EntityAddressType | null;
  idEntidadeEndereco: number | null;
  endereco: string;
  quantidade: number | null;
  quantidadeIdUnidadeMedida: string | null;
  minimoAceitavel: number | null;
  minimoAceitavelIdUnidadeMedida: string | null;
  preco: number | null;
  precificacao: BasicPricingData;
  observacao: string | null;
  quantidadeFornecedor: unknown;
};

type Props = {
  modoEdicao: boolean;
  requireSupplier?: boolean;
  referenceData: { entityTypeData?: EntityTypeType[]; unitOfMeasures: UnitOfMeasureType[] };
  origItem: ProposalResiduePlanQuotationTreatmentType | null;
  item: ProposalResiduePlanQuotationTreatmentType | null;
  refItem: ProposalResiduePlanTreatmentType;
  idPropostaResiduoPlanoCotacao?: number;
  defaultActiveKey?: string;
  zIndex: number;
  hidePricingSection?: boolean;
  hideCustomerSection?: boolean;
  submitLabel?: string;
  callback?: (
    item: ProposalResiduePlanQuotationTreatmentType | null,
    refItem: ProposalResiduePlanTreatmentType | null,
    action: string,
    confirmed: boolean
  ) => void | Promise<void>;
};

export type ResidueQuotationTreatmentFormRef = {
  submit(action?: string): Promise<boolean>;
};

const buildFornecedorDataFromItem = (
  item: ProposalResiduePlanQuotationTreatmentType | null
): EntitySearchResponseType | null => {
  if (!item || !item.idFornecedor) {
    return null;
  }
  return {
    ...buildFakeAuditObject(),
    idEntidade: Number(item.idFornecedor),
    tipos: [],
    cnpj: item.fornecedorCNPJ || null,
    razaoSocial: item.fornecedorRazaoSocial || null,
    nomeFantasia: item.fornecedorNomeFantasia || null,
    incricaoEstadual: null,
    incricaoMunicipal: null,
    cpf: item.fornecedorCPF || null,
    nome: item.fornecedorNome || null,
    webSite: null,
    aceitaEncontroContas: false,
  };
};

const buildEnderecoDataFromItem = (
  item: ProposalResiduePlanQuotationTreatmentType | null
): EntityAddressType | null => {
  if (!item || !item.idEntidadeEndereco) {
    return null;
  }
  return {
    ...buildFakeAuditObject(),
    idEntidadeEndereco: item.idEntidadeEndereco,
    idEntidade: item.idEntidade || null,
    codigoEstado: item.codigoEstado || '',
    cidade: item.cidade || '',
    cidadeCodigoIBGE: item.cidadeCodigoIBGE || null,
    bairro: item.bairro || '',
    logradouro: item.logradouro || '',
    numero: item.numero || '',
    complemento: item.complemento || null,
    referencia: item.referencia || null,
    cep: item.cep || '',
    latitude: item.latitude || null,
    longitude: item.longitude || null,
  } as EntityAddressType;
};

const buildInitialCustomerPricing = (
  item: ProposalResiduePlanQuotationTreatmentType | null,
  refItem: ProposalResiduePlanTreatmentType,
  unitOfMeasures: UnitOfMeasureType[]
): BasicPricingData => ({
  tipoPrecificacao: ProposalTipoPrecificacaoEnum.Especifica,
  quantidade:
    item?.precificacao?.quantidade ??
    refItem.precificacao?.quantidade ??
    item?.quantidade ??
    refItem.precificacao?.quantidade ??
    1,
  quantidadeIdUnidadeMedida:
    item?.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    refItem.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    item?.quantidadeIdUnidadeMedida?.toString() ||
    unitOfMeasures
      .find((x) => x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
      ?.idUnidadeMedida.toString() ||
    null,
  frequenciaIdUnidadeMedida: null,
  preco: item?.precificacao?.preco ?? refItem.precificacao?.preco ?? 0,
  imposto: item?.precificacao?.imposto ?? refItem.precificacao?.imposto ?? Financial.Tax,
});

const buildInitialValues = (
  item: ProposalResiduePlanQuotationTreatmentType | null,
  refItem: ProposalResiduePlanTreatmentType,
  unitOfMeasures: UnitOfMeasureType[]
): FormViewData => ({
  action: item ? Action.Nothing : Action.Add,
  id:
    item?.id ||
    item?.idTemporaria ||
    item?.idPropostaResiduoPlanoCotacaoTratamento?.toString() ||
    refItem?.id ||
    newGuid(),
  fornecedorData: buildFornecedorDataFromItem(item),
  idFornecedor: item?.idFornecedor || null,
  fornecedor: item?.fornecedorNomeFantasia || item?.fornecedorRazaoSocial || item?.fornecedorNome || '',
  idEntidadeResiduoTratamento: item?.idEntidadeResiduoTratamento || null,
  enderecoData: buildEnderecoDataFromItem(item),
  idEntidadeEndereco: item?.idEntidadeEndereco || null,
  endereco: item?.idEntidadeEndereco
    ? `${item.logradouro}, ${item.numero} | ${item.bairro} - ${item.cidade}/${item.codigoEstado}`
    : '',
  quantidade: item?.quantidade || null,
  quantidadeIdUnidadeMedida:
    item?.quantidadeIdUnidadeMedida?.toString() ||
    // refItem.precificacao?.quantidadeIdUnidadeMedida?.toString() ||
    null,
  minimoAceitavel: item?.minimoAceitavel || null,
  minimoAceitavelIdUnidadeMedida: item?.minimoAceitavelIdUnidadeMedida?.toString() || null,
  preco: item?.preco ?? null,
  precificacao: buildInitialCustomerPricing(item, refItem, unitOfMeasures),
  observacao: item?.observacao || '',
  quantidadeFornecedor: null,
});

const buildPricingTypeFromQuotation = (
  pricingData: BasicPricingData,
  unitOfMeasures: UnitOfMeasureType[]
): ProposalResiduePlanPricingType => {
  const quantidadeIdUnidadeMedida = pricingData.quantidadeIdUnidadeMedida
    ? Number(pricingData.quantidadeIdUnidadeMedida)
    : null;

  return {
    tipo: ProposalTipoPrecificacaoEnum.Especifica,
    quantidade: pricingData.quantidade,
    quantidadeIdUnidadeMedida,
    quantidadeUnidadeMedida:
      unitOfMeasures.find((x) => x.idUnidadeMedida === quantidadeIdUnidadeMedida)?.unidadeMedida || null,
    quantidadeUnidadeMedidaSigla:
      unitOfMeasures.find((x) => x.idUnidadeMedida === quantidadeIdUnidadeMedida)?.unidadeMedidaSigla || null,
    frequenciaIdUnidadeMedida: null,
    frequenciaUnidadeMedida: null,
    frequenciaUnidadeMedidaSigla: null,
    preco: pricingData.preco,
    imposto: pricingData.imposto,
  };
};

const ResidueQuotationTreatmentForm = forwardRef<ResidueQuotationTreatmentFormRef, Props>((props, ref) => {
  const refToleranceForm = useRef<any>();
  const refQuantity = useRef<BasicValueUnitsRef>(null);
  const refMinimum = useRef<BasicValueUnitsRef>(null);
  const refSupplierPriceTax = useRef<BasicPriceTaxRef>(null);
  const refCustomerPricing = useRef<BasicPricingRef>(null);
  const disabled = !props.modoEdicao;

  const form = useForm<FormViewData>({
    initialValues: buildInitialValues(props.item, props.refItem, props.referenceData.unitOfMeasures),
    validate: {
      idFornecedor: (value) => (props.requireSupplier && (!value || value <= 0) ? 'Campo obrigatório' : null),
      idEntidadeEndereco: (value, values) =>
        values.idFornecedor && (!value || value <= 0) ? 'Campo obrigatório' : null,
    },
  });

  const itemKey =
    props.item?.id ||
    props.item?.idPropostaResiduoPlanoCotacaoTratamento?.toString() ||
    props.item?.idTemporaria ||
    'new';
  const refItemKey =
    props.refItem?.id ||
    props.refItem?.idPropostaResiduoPlanoTratamento?.toString() ||
    props.refItem?.idTemporaria ||
    props.refItem?.idResiduoTratamento?.toString() ||
    'ref';

  useEffect(() => {
    form.setValues(buildInitialValues(props.item, props.refItem, props.referenceData.unitOfMeasures));
    form.resetDirty();
    form.clearErrors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemKey, refItemKey]);

  const quantityUnitOptions = props.referenceData.unitOfMeasures
    .filter(
      (x) =>
        x.tipo === 'Massa' || x.tipo === 'Volume' || (x.tipo === 'Outro' && x.unidadeMedidaSigla === 'un')
    )
    .map((x) => ({
      value: x.idUnidadeMedida.toString(),
      label: `${x.unidadeMedida} (${x.unidadeMedidaSigla})`,
      group: x.tipo,
    }));

  const inheritedCustomerPricingData = useMemo<BasicPricingData>(
    () => buildInitialCustomerPricing(props.item, props.refItem, props.referenceData.unitOfMeasures),
    [props.item, props.refItem, props.referenceData.unitOfMeasures]
  );

  const isSupplierDefined = !!form.values.idFornecedor;

  const isModified = (
    quantityData?: BasicValueUnitsData | null,
    minimumData?: BasicValueUnitsData | null,
    supplierPriceTaxData?: { preco: number | null; imposto: number | null } | null,
    customerPricingData?: BasicPricingData | null
  ) => {
    const origData = `${props.origItem?.idFornecedor || ''}|${
      props.origItem?.idEntidadeResiduoTratamento || ''
    }|${props.origItem?.idEntidadeEndereco || ''}|${props.origItem?.quantidade || ''}|${
      props.origItem?.quantidadeIdUnidadeMedida || ''
    }|${Number(props.origItem?.minimoAceitavel) || ''}|${
      props.origItem?.minimoAceitavelIdUnidadeMedida || ''
    }|${Number(props.origItem?.preco) || ''}|${Number(props.origItem?.precificacao?.quantidade) || ''}|${
      props.origItem?.precificacao?.quantidadeIdUnidadeMedida || ''
    }|${Number(props.origItem?.precificacao?.preco) || ''}|${
      Number(props.origItem?.precificacao?.imposto) || ''
    }|${props.origItem?.observacao || ''}`;

    const formData = `${form.values.idFornecedor || ''}|${form.values.idEntidadeResiduoTratamento || ''}|${
      form.values.idEntidadeEndereco || ''
    }|${quantityData?.valor ?? ''}|${quantityData?.idUnidade1 || ''}|${minimumData?.valor ?? ''}|${
      minimumData?.idUnidade1 || ''
    }|${supplierPriceTaxData?.preco ?? ''}|${customerPricingData?.quantidade ?? ''}|${
      customerPricingData?.quantidadeIdUnidadeMedida || ''
    }|${customerPricingData?.preco ?? ''}|${customerPricingData?.imposto ?? ''}|${
      form.values.observacao || ''
    }`;

    return origData !== formData;
  };

  const clearFornecedorData = () => {
    form.setFieldValue('fornecedorData', null);
    form.setFieldValue('idFornecedor', undefined as never as null);
    form.setFieldValue('fornecedor', '');
    form.setFieldValue('enderecoData', null);
    form.setFieldValue('idEntidadeEndereco', null);
    form.setFieldValue('endereco', '');
    form.setFieldValue('preco', '' as never as null);
    form.setFieldValue('quantidade', null);
    form.setFieldValue('quantidadeIdUnidadeMedida', null);
    form.setFieldValue('minimoAceitavel', undefined as never as null);
    form.setFieldValue('minimoAceitavelIdUnidadeMedida', undefined as never as null);
    refSupplierPriceTax.current?.clear();
    refQuantity.current?.clear();
    refMinimum.current?.clear();
  };

  const handleSubmit = async (action = 'callback'): Promise<boolean> => {
    const formValidation = form.validate();
    const quantityData = !isSupplierDefined
      ? { valor: null, idUnidade1: null, idUnidade2: null }
      : refQuantity.current?.validate();
    const minimumData = !isSupplierDefined
      ? { valor: null, idUnidade1: null, idUnidade2: null }
      : refMinimum.current?.validate();
    const supplierPriceTaxData = !isSupplierDefined
      ? { preco: null, imposto: null }
      : refSupplierPriceTax.current?.validate();
    const customerPricingData = props.hideCustomerSection
      ? inheritedCustomerPricingData
      : refCustomerPricing.current?.validate();

    if (
      formValidation.hasErrors ||
      !quantityData ||
      !minimumData ||
      !supplierPriceTaxData ||
      !customerPricingData
    ) {
      return false;
    }

    if (!isNullOrEmpty(supplierPriceTaxData.preco) && isNullOrEmpty(quantityData.valor)) {
      form.setFieldError(
        'quantidadeFornecedor',
        <Text size="xs" mt={5}>
          Campo obrigatório quando o preço é informado.
        </Text>
      );
      return false;
    }

    let values = { ...form.values };
    let nextAction = values.action;

    if (props.origItem) {
      if (
        isModified(quantityData, minimumData, supplierPriceTaxData, customerPricingData) &&
        props.origItem.idPropostaResiduoPlanoCotacaoTratamento
      ) {
        nextAction = Action.Modify;
      } else {
        values = {
          ...props.origItem,
          ...values,
          action: props.item?.action || Action.Nothing,
          quantidadeIdUnidadeMedida: quantityData.idUnidade1 || '',
          minimoAceitavelIdUnidadeMedida: minimumData.idUnidade1 || '',
        };
        nextAction = values.action;
      }
    }

    const formItem: ProposalResiduePlanQuotationTreatmentType = {
      ...buildFakeAuditObject(),
      ...(props.origItem || {}),
      ...values,
      action: nextAction,
      id: values.id,
      idTemporaria: props.origItem?.idTemporaria || values.id,
      idPropostaResiduoPlanoCotacao:
        props.idPropostaResiduoPlanoCotacao || props.origItem?.idPropostaResiduoPlanoCotacao || -1,
      quantidade: quantityData.valor === null ? null : Number(quantityData.valor),
      quantidadeIdUnidadeMedida: quantityData.idUnidade1 ? Number(quantityData.idUnidade1) : null,
      minimoAceitavel: minimumData.valor === null ? null : minimumData.valor,
      minimoAceitavelIdUnidadeMedida: minimumData.idUnidade1 ? Number(minimumData.idUnidade1) : null,
      preco: supplierPriceTaxData.preco,
      precificacao: buildPricingTypeFromQuotation(customerPricingData, props.referenceData.unitOfMeasures),
    };

    formItem.quantidadeUnidadeMedida =
      formItem.quantidadeIdUnidadeMedida === null
        ? null
        : props.referenceData.unitOfMeasures.find(
            (x) => x.idUnidadeMedida === Number(quantityData.idUnidade1)
          )?.unidadeMedida || null;
    formItem.quantidadeUnidadeMedidaSigla =
      formItem.quantidadeIdUnidadeMedida === null
        ? null
        : props.referenceData.unitOfMeasures.find(
            (x) => x.idUnidadeMedida === Number(quantityData.idUnidade1)
          )?.unidadeMedidaSigla || null;
    formItem.minimoAceitavelUnidadeMedida =
      formItem.minimoAceitavelIdUnidadeMedida === null
        ? null
        : props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === Number(minimumData.idUnidade1))
            ?.unidadeMedida || null;
    formItem.minimoAceitavelUnidadeMedidaSigla =
      formItem.minimoAceitavelIdUnidadeMedida === null
        ? null
        : props.referenceData.unitOfMeasures.find((x) => x.idUnidadeMedida === Number(minimumData.idUnidade1))
            ?.unidadeMedidaSigla || null;

    formItem.preco = formItem.preco === null ? null : Number(formItem.preco);
    formItem.idFornecedor =
      form.values.fornecedorData?.idEntidade || form.values.idFornecedor
        ? Number(form.values.fornecedorData?.idEntidade || form.values.idFornecedor)
        : null;
    formItem.fornecedorCNPJ = form.values.fornecedorData?.cnpj || props.item?.fornecedorCNPJ || null;
    formItem.fornecedorRazaoSocial =
      form.values.fornecedorData?.razaoSocial || props.item?.fornecedorRazaoSocial || null;
    formItem.fornecedorNomeFantasia =
      form.values.fornecedorData?.nomeFantasia || props.item?.fornecedorNomeFantasia || null;
    formItem.fornecedorCPF = form.values.fornecedorData?.cpf || props.item?.fornecedorCPF || null;
    formItem.fornecedorNome = form.values.fornecedorData?.nome || props.item?.fornecedorNome || null;
    formItem.idEntidadeEndereco = form.values.idEntidadeEndereco
      ? Number(form.values.idEntidadeEndereco)
      : null;
    formItem.idEntidade = form.values.fornecedorData?.idEntidade || props.item?.idEntidade || null;
    formItem.codigoEstado = form.values.enderecoData?.codigoEstado || props.item?.codigoEstado || null;
    formItem.cidade = form.values.enderecoData?.cidade || props.item?.cidade || null;
    formItem.cidadeCodigoIBGE =
      form.values.enderecoData?.cidadeCodigoIBGE || props.item?.cidadeCodigoIBGE || null;
    formItem.bairro = form.values.enderecoData?.bairro || props.item?.bairro || null;
    formItem.logradouro = form.values.enderecoData?.logradouro || props.item?.logradouro || null;
    formItem.numero = form.values.enderecoData?.numero || props.item?.numero || null;
    formItem.complemento = form.values.enderecoData?.complemento || props.item?.complemento || null;
    formItem.referencia = form.values.enderecoData?.referencia || props.item?.referencia || null;
    formItem.cep = form.values.enderecoData?.cep || props.item?.cep || '';
    formItem.latitude = form.values.enderecoData?.latitude || props.item?.latitude || null;
    formItem.longitude = form.values.enderecoData?.longitude || props.item?.longitude || null;
    formItem.idPropostaResiduoPlanoTratamento =
      props.refItem?.idPropostaResiduoPlanoTratamento || props.origItem?.idPropostaResiduoPlanoTratamento;
    formItem.idResiduoTratamento = props.refItem?.idResiduoTratamento || -1;
    formItem.residuoTratamento = props.refItem?.residuoTratamento || '';
    formItem.residuoTratamentoDescricao = props.refItem?.residuoTratamentoDescricao || null;
    formItem.observacao = formItem.observacao?.trim() || null;
    formItem.tolerancias = refToleranceForm.current?.validate() || props.item?.tolerancias || [];

    if (!isSupplierDefined) {
      formItem.idFornecedor = null;
      formItem.fornecedorCNPJ = null;
      formItem.fornecedorRazaoSocial = null;
      formItem.fornecedorNomeFantasia = null;
      formItem.fornecedorCPF = null;
      formItem.fornecedorNome = null;
      formItem.idEntidadeResiduoTratamento = null;
      formItem.idEntidadeEndereco = null;
      formItem.idEntidade = null;
      formItem.codigoEstado = null;
      formItem.cidade = null;
      formItem.cidadeCodigoIBGE = null;
      formItem.bairro = null;
      formItem.logradouro = null;
      formItem.numero = null;
      formItem.complemento = null;
      formItem.referencia = null;
      formItem.cep = '';
      formItem.latitude = null;
      formItem.longitude = null;
      formItem.quantidade = null;
      formItem.quantidadeIdUnidadeMedida = null;
      formItem.quantidadeUnidadeMedida = null;
      formItem.quantidadeUnidadeMedidaSigla = null;
      formItem.minimoAceitavel = null;
      formItem.minimoAceitavelIdUnidadeMedida = null;
      formItem.minimoAceitavelUnidadeMedida = null;
      formItem.minimoAceitavelUnidadeMedidaSigla = null;
      formItem.preco = null;
    }

    (formItem as any).refItem = props.refItem;
    await props.callback?.(formItem, props.refItem, action, true);
    return true;
  };

  useImperativeHandle(ref, () => ({
    submit(action = 'callback') {
      return handleSubmit(action);
    },
  }));

  const tabs = [
    {
      key: 'Cotacao',
      forceRender: true,
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconZoomMoney size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Cotação
          </Text>
        </Group>
      ),
      children: (
        <>
          {!props.hideCustomerSection && (
            <>
              <Grid columns={4}>
                <Grid.Col span={4}>
                  <Paper shadow="xs" p="md" withBorder>
                    <PageSection
                      size="md"
                      color={Feature.Home.Proposal.color}
                      label="Cliente"
                      text="Informações operacionais da cotação com o cliente."
                    />
                    <Space h="xs" />
                    <BasicPricing
                      ref={refCustomerPricing}
                      isEdit={props.modoEdicao}
                      disabled={disabled}
                      quantityUnitDisabled={false}
                      hideTipoPrecificacaoSelector
                      forcePricingActive
                      withFrequency={false}
                      value={{
                        ...form.values.precificacao,
                        tipoPrecificacao: ProposalTipoPrecificacaoEnum.Especifica,
                      }}
                      onChange={(pricingData) => {
                        form.setFieldValue('precificacao', pricingData);
                      }}
                      quantityUnitOptions={quantityUnitOptions}
                      zIndex={props.zIndex + 1}
                    />
                  </Paper>
                </Grid.Col>
              </Grid>
              <Space h="md" />
            </>
          )}

          <Paper shadow="xs" p="md" withBorder>
            <Group justify="space-between">
              <PageSection
                size="md"
                color={Feature.Home.Proposal.color}
                label="Fornecedor"
                text="Informações operacionais da cotação com o fornecedor."
              />
              {isSupplierDefined && (
                <Button size="xs" color="orange" onClick={clearFornecedorData} disabled={disabled}>
                  Limpar
                </Button>
              )}
            </Group>
            <Space h="xs" />
            <Grid columns={4}>
              <Grid.Col span={2}>
                <EntityItemPicker
                  label="Fornecedor"
                  item={EntityItemEnum.Treatment}
                  itemId={props.refItem?.idResiduoTratamento || -1}
                  formItem={form.getInputProps('idFornecedor') || undefined}
                  idsToBeDisabled={[]}
                  callback={async (item: EntitySearchResponseType | null) => {
                    if (item) {
                      form.setFieldValue('fornecedorData', item);
                      form.setFieldValue('idFornecedor', item.idEntidade);
                      form.setFieldValue(
                        'fornecedor',
                        item.nomeFantasia || item.razaoSocial || item.nome || ''
                      );
                      form.setFieldValue(
                        'idEntidadeResiduoTratamento',
                        (item as any).idEntidadeResiduoTratamento
                      );
                      form.setFieldValue('enderecoData', null);
                      form.setFieldValue('idEntidadeEndereco', null);
                      form.setFieldValue('endereco', '');
                    }
                  }}
                  required={!!props.requireSupplier}
                  disabled={disabled}
                  zIndex={props.zIndex + 1}
                />
              </Grid.Col>
              <Grid.Col span={2}>
                <EntityAddressPicker
                  key={form.values.idFornecedor || -1}
                  label="Endereço"
                  idEntidade={form.values.idFornecedor || -1}
                  formItem={form.getInputProps('idEntidadeEndereco')}
                  idsToBeDisabled={[]}
                  callback={async (item: EntityAddressType | null) => {
                    if (item) {
                      form.setFieldValue('enderecoData', item);
                      form.setFieldValue('idEntidadeEndereco', item.idEntidadeEndereco!);
                      form.setFieldValue(
                        'endereco',
                        `${item.logradouro}, ${item.numero} | ${item.bairro} - ${item.cidade}/${item.codigoEstado}`
                      );
                    }
                  }}
                  required={isSupplierDefined}
                  disabled={disabled || !isSupplierDefined}
                  zIndex={props.zIndex + 1}
                />
              </Grid.Col>

              {isSupplierDefined && (
                <>
                  <Grid.Col span={2}>
                    <BasicValueUnits
                      ref={refQuantity}
                      isEdit={props.modoEdicao}
                      disabled={disabled || !isSupplierDefined}
                      zIndex={props.zIndex + 1}
                      label="Quantidade"
                      showUnit2={false}
                      validationMode="all-or-none"
                      valueMin={0}
                      valueMustBePositiveWhenFilled
                      value={{
                        valor: form.values.quantidade,
                        idUnidade1: form.values.quantidadeIdUnidadeMedida,
                        idUnidade2: null,
                      }}
                      onChange={(quantityData) => {
                        form.setFieldValue('quantidade', quantityData.valor);
                        form.setFieldValue('quantidadeIdUnidadeMedida', quantityData.idUnidade1);
                      }}
                      unit1Options={quantityUnitOptions}
                    />
                  </Grid.Col>
                  <Grid.Col span={2}>
                    <BasicPriceTax
                      ref={refSupplierPriceTax}
                      isEdit={props.modoEdicao}
                      disabled={disabled || !isSupplierDefined}
                      requiredPrice={!isNullOrEmpty(form.values.quantidade)}
                      showTax={false}
                      labelPreco="Preço"
                      value={{
                        preco: form.values.preco,
                        imposto: null,
                      }}
                      zIndex={props.zIndex + 1}
                    />
                  </Grid.Col>

                  <Grid.Col span={4}>
                    <BasicValueUnits
                      ref={refMinimum}
                      isEdit={props.modoEdicao}
                      disabled={disabled || !isSupplierDefined}
                      zIndex={props.zIndex + 1}
                      label="Mínimo Aceitável"
                      showUnit2={false}
                      validationMode="all-or-none"
                      value={{
                        valor: form.values.minimoAceitavel,
                        idUnidade1: form.values.minimoAceitavelIdUnidadeMedida,
                        idUnidade2: null,
                      }}
                      unit1Options={quantityUnitOptions}
                    />
                  </Grid.Col>
                </>
              )}

              <Grid.Col span={4}>
                <Textarea
                  leftSection={<IconNotes size={15} />}
                  label="Observação"
                  placeholder="Observação sobre a cotação do tratamento"
                  autosize
                  maxLength={500}
                  disabled={disabled}
                  {...form.getInputProps('observacao')}
                />
              </Grid.Col>
            </Grid>
          </Paper>
        </>
      ),
    },
    {
      key: 'Tolerancias',
      forceRender: true,
      label: (
        <Group>
          <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
            <IconScale size={18} />
          </ThemeIcon>
          <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
            Tolerâncias
          </Text>
        </Group>
      ),
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <ToleranceForm
            ref={refToleranceForm}
            refId={props.item?.idPropostaResiduoPlanoCotacaoTratamento}
            title="Tolerâncias"
            description="Tolerâncias para esta cotação."
            color={Feature.Home.Proposal.color}
            disabled={!props.modoEdicao}
            origData={props.origItem?.tolerancias || []}
            data={props.item?.tolerancias || []}
            referenceData={props.referenceData}
            zIndex={props.zIndex + 1}
          />
        </Paper>
      ),
    },
  ];

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Tabs items={tabs} defaultActiveKey={props.defaultActiveKey || 'Cotacao'} />
      <Space h="md" />
      {props.modoEdicao && (
        <Group justify="right">
          <Button
            leftSection={<IconDeviceFloppy size={18} />}
            onClick={() => {
              handleSubmit();
            }}
          >
            {props.submitLabel || 'Salvar cotação'}
          </Button>
        </Group>
      )}
    </Paper>
  );
});

export default ResidueQuotationTreatmentForm;
